import React, { ReactElement } from 'react'
import { Button, IButtonProps } from '@blueprintjs/core'
import Icon from './FAIcon'
import css from './nonIdealState.module.scss'

interface IconProps {
  name: string
  color: string
  background: string
}

interface NonIdealStateProps {
  iconProps: IconProps
  buttonProps?: IButtonProps
  message: ReactElement<any> | string
}

export default function NonIdealState({ iconProps, message, buttonProps }: NonIdealStateProps) {
  return (
    <div className={css.container}>
      <div className={css.container__icon_wrapper} style={{ background: iconProps.background }}>
        <Icon name={iconProps.name} style={{ fontSize: 52, color: iconProps.color }} />
      </div>
      <div className={css.container__message_wrapper}>{message}</div>
      {buttonProps && (
        <div className={css.container__button_wrapper}>
          <Button {...buttonProps} />
        </div>
      )}
    </div>
  )
}
